import React, { useState, useEffect } from "react";
import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import LoadingPage from "../../../services/LoadingPage";
import { sto } from "../../../Context/InshData";
import UsersPermission from "./UsersPermission";
import { uri } from "../../../help/Api";
const defaultAutos = {
    Branches: [],
};

export default function UsersPermissionCon() {
  const tb = {
    wait: true,
    BranchDate:true,
    UsersAll:true,
    AllAccountsIndex:true,
    stor: sto,
    parms: { 
        tname:"intermed" , 
        iempid: sto.empi,
        branch:sto.branchi
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb
  );

  if (fetchAll  ||!AutoOptions || !AutoOptions?.Users || !AutoOptions.Accindex) return <LoadingPage />;

  return (
    <UsersPermission
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
      }}
    />
  );
}
